import { useState } from 'react';
import { RotateCw } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import { flushPendingSaves } from '../store/unsaved.js';

// Bouton « Actualiser » de la topbar (desktop + mobile) et de l'en-tête
// de l'Espace employé. Recharge les données, pas la page : un reload
// complet perdrait les brouillons en cours, alors qu'ici seules les
// requêtes React Query sont invalidées (les actives se rechargent, les
// autres le seront à leur prochain affichage). Les sauvegardes
// automatiques en attente partent d'abord, pour ne pas être écrasées
// par la réponse rafraîchie.
const MIN_SPIN_MS = 600;

export function RefreshButton({ className = 'icon-button' }: { className?: string }) {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    flushPendingSaves();
    const started = Date.now();
    try {
      await qc.invalidateQueries();
    } finally {
      // Un tour d'icône minimum : une réponse instantanée resterait
      // sinon invisible et l'on recliquerait.
      const left = MIN_SPIN_MS - (Date.now() - started);
      if (left > 0) await new Promise((r) => setTimeout(r, left));
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={`${className} refresh-button`}
      onClick={() => void onClick()}
      disabled={busy}
      aria-label="Actualiser les données"
      aria-busy={busy}
      title="Actualiser"
      data-testid="refresh-button"
    >
      <RotateCw aria-hidden="true" className={busy ? 'refresh-spin' : undefined} />
    </button>
  );
}
